module.exports = __webpack_public_path__ + "img/parking-sign.9c5aaa25.svg";